module.exports = __webpack_public_path__ + "youtube.svg?5d1c83d229db4a9cd052e9e9cb2f9914";